var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 110.03056,
    height: 107.5,
    viewBox: "0 0 88.024445 86",
    id: "svg2",
    inkscapeVersion: "0.92.2 (5c3e80d, 2017-08-06)",
    sodipodiDocname: "Microsoft_PowerPoint_2013_logo.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs124"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,204 H 250.91 V 0 H 0 Z",
    id: "path16",
    "inkscapeConnector-curvature": 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.48158935,0,0,-0.49500577,-16.645044,93.37089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(211.3203,43.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 m -0.01,0 h -72.24 v 15.083 h 56.333 v 7 H -72.25 v 11.833 h 56.333 v 7 H -72.25 v 19.453 c 4.539,-5.322 11.289,-8.702 18.833,-8.702 13.669,0 24.749,11.081 24.749,24.749 h -24.749 v 24.749 c -7.544,0 -14.294,-3.38 -18.833,-8.702 V 120 H 0 Z M 0,126 h -72.25 v 18.874 l -104.5,-18.131 V -10.745 l 104.5,-18.131 V -6 H 0 c 3.309,0 6,2.691 6,6 v 120 c 0,3.309 -2.691,6 -6,6",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22",
    "inkscapeConnector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(161.7363,148.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -24.749 H 24.749 C 24.749,-11.081 13.669,0 0,0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26",
    "inkscapeConnector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(78.7876,102.8086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.169,-0.32 8.241,-1.099 10.773,3.223 1.914,3.261 1.753,9.22 -0.467,11.726 C 7.435,18.189 3.726,17.727 0,17.137 Z m -0.294,-30.68 h -10.467 v 58.422 c 8.075,0 16.109,0.227 24.113,-0.153 2.104,-0.1 4.547,-1.664 6.1,-3.268 5.944,-6.137 5.945,-13.782 4.169,-21.407 -1.583,-6.791 -5.964,-11.569 -12.869,-13.249 -3.44,-0.837 -7.121,-0.683 -11.046,-1.006 z",
    style: {
      fill: "#cb4a32",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path30",
    "inkscapeConnector-curvature": 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.736a7921d2ad7977ad67043f9320c3e2.svg";
export { ForwardRef as ReactComponent };